import { META_PIXEL_ID } from '../data/content';

type FbqStub = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: FbqStub;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: FbqStub;
    _fbq?: FbqStub;
  }
}

/** The pixel only runs with a real numeric id: nothing is initialized or fired with the 'PIXEL_FR_PENDIENTE' placeholder. */
export const pixelEnabled = /^\d{10,20}$/.test(META_PIXEL_ID);

let initialized = false;

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized || !pixelEnabled) return;
  initialized = true;

  if (!window.fbq) {
    const stub = function (...args: unknown[]) {
      if (stub.callMethod) stub.callMethod(...args);
      else stub.queue.push(args);
    } as FbqStub;
    stub.push = stub;
    stub.loaded = true;
    stub.version = '2.0';
    stub.queue = [];
    window.fbq = stub;
    if (!window._fbq) window._fbq = stub;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  window.fbq?.('init', META_PIXEL_ID);
  window.fbq?.('track', 'PageView');
}

export function trackPixel(event: 'InitiateCheckout' | 'ViewContent') {
  if (typeof window === 'undefined' || !pixelEnabled) return;
  window.fbq?.('track', event);
}
